"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToasterContainer = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var ConfigProvider_1 = require("../ConfigProvider");
var utils_1 = require("../utils");
var icons_1 = require("../icons");
var Container_1 = require("./Container");
Object.defineProperty(exports, "ToasterContainer", { enumerable: true, get: function () { return tslib_1.__importDefault(Container_1).default; } });
function Toaster(props) {
    var className = props.className, message = props.message, _a = props.type, type = _a === void 0 ? 'info' : _a, rootHtmlProps = props.rootHtmlProps, style = props.style;
    var prefix = ConfigProvider_1.usePrefix('toaster');
    var typePrefix = utils_1.concat(prefix, type);
    var iconPrefix = utils_1.concat(prefix, 'icon');
    var messagePrefix = utils_1.concat(prefix, 'message');
    var innerIcon = getIconByType(type);
    var cls = classnames_1.default(className, prefix, typePrefix, rootHtmlProps === null || rootHtmlProps === void 0 ? void 0 : rootHtmlProps.className);
    return (react_1.default.createElement("div", tslib_1.__assign({}, rootHtmlProps, { className: cls, style: tslib_1.__assign(tslib_1.__assign({}, style), rootHtmlProps === null || rootHtmlProps === void 0 ? void 0 : rootHtmlProps.style) }),
        react_1.default.createElement("div", { className: iconPrefix }, innerIcon),
        react_1.default.createElement("div", { className: messagePrefix }, message)));
}
exports.default = Toaster;
function getIconByType(type) {
    switch (type) {
        case 'info':
        default:
            return react_1.default.createElement(icons_1.InfoIcon, null);
        case 'success':
            return react_1.default.createElement(icons_1.CheckCircleIcon, null);
        case 'error':
            return react_1.default.createElement(icons_1.CloseCircleIcon, null);
        case 'warning':
            return react_1.default.createElement(icons_1.TipIcon, null);
    }
}
//# sourceMappingURL=index.js.map